import React from 'react';
import { PlayerVod } from './player-vod';
import { PlayerLive } from './player-live';
import classNames from 'classnames';
import styles from './player-bar.css';

export const PlayerBar = ({
  isVod,
  playerState,
  setIsPinRequired,
  setIdleState,
  handleError,
  refreshPrograms,
  setRoute,
  content
}) => {
  return (
    <div onTransitionEnd={setIdleState} className={classNames([styles.main, styles[playerState]])}>
      {isVod ? (
        <PlayerVod {...content} />
      ) : (
        <PlayerLive
          setIsPinRequired={setIsPinRequired}
          handleError={handleError}
          refreshPrograms={refreshPrograms}
          setRoute={setRoute}
          {...content}
        />
      )}
    </div>
  );
};
